import { Form } from 'antd';
import BaseModal from 'basic-ui-lib/components/Modal/BaseModal';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';
import InputLarge from 'basic-ui-lib/components/Input/InputLarge';
import toast from 'utils/toast';

export interface AddWebviewLinkModalRef {
  open: (onConfirm?: (data: FormValues) => void) => void;
}

interface Props {}

interface FormValues {
  url: string;
  name: string;
}

const AddWebviewLinkModal = forwardRef<AddWebviewLinkModalRef, Props>(({}, ref) => {
  const [form] = Form.useForm();
  const [isOpen, setIsOpen] = useState(false);
  const onConfirmRef = useRef<(data: FormValues) => void>(() => undefined);

  useImperativeHandle(ref, () => ({
    open: (onConfirm?: (data: FormValues) => void) => {
      setIsOpen(true);
      if (onConfirm) {
        onConfirmRef.current = onConfirm;
      }
    },
  }));

  const onClose = () => {
    setIsOpen(false);
    form.resetFields();
  };

  const handleSubmit = () => {
    form.submit();
  };

  const handleFinish = async (values: FormValues) => {
    onConfirmRef.current(values);
    onClose();
    toast.success('Webview link added successfully');
  };
  
  return (
    <BaseModal title='Add Link' isOpen={isOpen} width={1000} onClose={onClose} okText='Continue' onOk={handleSubmit}>
      <Container>
        <Form layout='vertical' form={form} onFinish={handleFinish}>
          <Form.Item name='url' rules={[{ required: true, message: 'Please input URL' }]}>
            <InputLarge placeholder='Enter URL' />
          </Form.Item>
          <Form.Item name='name' rules={[{ required: true, message: 'Please input link name' }]}>
            <InputLarge placeholder='Link Name' />
          </Form.Item>
        </Form>
      </Container>
    </BaseModal>
  );
});

AddWebviewLinkModal.displayName = 'AddWebviewLinkModal';
export default AddWebviewLinkModal;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding: 0 50px;
`;
